import { VALIDATION_PATTERNS } from '../../config'

export const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()[\]\\]/g, '\\$&')

export const dataStreamURIValidate = (allowedDomains: string[]) => (
  value: string
): string | undefined => {
  if (!value) {
    return 'URL is required'
  } else if (!VALIDATION_PATTERNS.URL.test(value)) {
    return 'Link is not a web address'
  } else if (
    !new RegExp(
      `/(www.)*${escapeRegExp(allowedDomains.join('|'))}[/?#]?`,
      'gi'
    ).test(value)
  ) {
    const parts = value.split('/')
    const domain = (parts && parts[2]) || value
    return `Domain is not supported: ${domain}`
  }
}
